export default {"src":"/_next/static/media/roofing.24c48284.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};